__turbopack_context__.v({
  "className": "G-UaBW_className",
  "variable": "G-UaBW_variable",
});
